export default [
  '#454bff',
  '#35bcff',
  '#ffc132',
  '#d13800',
  '#e467ba',
  '#ffbe0b',
  '#fb5607',
  '#ff006e',
  '#8338ec',
  '#3a86ff',
  '#7231ff',
  '#ae36ff',
  '#30e1ac',
  '#eb3e3e',
  '#ff508d',
  '#574d68',
  '#a38560',
  '#c6a15b',
  '#f2e86d',
  '#d3dfb8',
  '#e06c9f',
  '#f283b6',
  '#edbfb7',
  '#bcbfa1',
  '#5e8474',
  '#8ecae6',
  '#219ebc',
  '#023047',
  '#ffb703',
  '#fb8500',
  '#ffbe0b',
  '#fb5607',
  '#ff006e',
  '#8338ec',
  '#3a86ff',
  '#780000',
  '#c1121f',
  '#fdf0d5',
  '#003049',
  '#669bbc',
  '#f72585',
  '#7209b7',
  '#3a0ca3',
  '#4361ee',
  '#4cc9f0',
  '#03045e',
  '#0077b6',
  '#00b4d8',
  '#90e0ef',
  '#caf0f8',
  '#335c67',
  '#fff3b0',
  '#e09f3e',
  '#9e2a2b',
  '#540b0e',
  '#d8e2dc',
  '#ffe5d9',
  '#ffcad4',
  '#f4acb7',
  '#9d8189',
  '#e07a5f',
  '#3d405b',
  '#81b29a',
  '#f2cc8f',
];
